module.exports = __webpack_public_path__ + "static/media/bullmoose.b4c4cd99.png";